var map = {
	"./2_services_person_1.jpg": 20,
	"./4 СМЕТА_.jpg": 21,
	"./6 АВТОРСКИЙ_.jpg": 22,
	"./8 КОНСУЛЬТАЦИИ_.jpg": 23,
	"./about/1 Оксана Вдовина ведущий дизайнер.jpg": 24,
	"./about/2 Евгения Каплина дизайнер, главный проектировщик.jpg": 25,
	"./about/2 Оксана Вдовина ведущий дизайнер.jpg": 26,
	"./about/3 Юлия Шиман дизайнер.jpg": 27,
	"./about/4 Юлия Шалухина дизайнер.jpg": 28,
	"./about/5 Татьяна Шишенина проектировщик.jpg": 29,
	"./about_logo.jpg": 30,
	"./design-examples/3 primer rabochego proecta с текстом-01.png": 31,
	"./design-examples/3 primer rabochego proecta с текстом-02.png": 32,
	"./design-examples/3 primer rabochego proecta с текстом-03.png": 33,
	"./design-examples/3 primer rabochego proecta с текстом-04.png": 34,
	"./design-examples/3 primer rabochego proecta с текстом-05.png": 35,
	"./design-examples/3 primer rabochego proecta с текстом-06.png": 36,
	"./design-examples/3 primer rabochego proecta с текстом-07.png": 37,
	"./design-examples/3 primer rabochego proecta с текстом-08.png": 38,
	"./design-examples/3 primer rabochego proecta с текстом-09.png": 39,
	"./design-examples/3 primer rabochego proecta с текстом-10.png": 40,
	"./design-examples/3 primer rabochego proecta с текстом-11.png": 41,
	"./design-examples/3 primer rabochego proecta с текстом-12.png": 42,
	"./design-examples/3 primer rabochego proecta с текстом-13.png": 43,
	"./design-examples/3 primer rabochego proecta с текстом-14.png": 44,
	"./design-examples/3 primer rabochego proecta с текстом-15.png": 45,
	"./design-examples/3 primer rabochego proecta с текстом-16.png": 46,
	"./design-examples/3 primer rabochego proecta с текстом-17.png": 47,
	"./design-examples/3 primer rabochego proecta с текстом-18.png": 48,
	"./design-examples/3 primer rabochego proecta с текстом-19.png": 49,
	"./favicon/4 СМЕТА_.jpg": 50,
	"./favicon/6 АВТОРСКИЙ_.jpg": 51,
	"./favicon/8 КОНСУЛЬТАЦИИ_.jpg": 52,
	"./favicon/android-chrome-192x192.png": 53,
	"./favicon/android-chrome-512x512.png": 54,
	"./favicon/apple-touch-icon.png": 55,
	"./favicon/favicon-16x16.png": 56,
	"./favicon/favicon-32x32.png": 57,
	"./favicon/favicon.ico": 58,
	"./index_block1_1.jpg": 59,
	"./index_block4_1.jpg": 60,
	"./index_block4_2.jpg": 61,
	"./index_paralax_0.jpg": 62,
	"./polzunok.png": 63,
	"./vr_glass.jpg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;